import WalletsFilter from "./WalletsFilter";
import WalletsTable from "./WalletsTable";

export {
    WalletsFilter,
    WalletsTable
}